/**
 * A collection to represent model.get('options') within the Multiselect view. As a backbone collection instead of
 * an array, this allows us to display the model options in a typeahead modal, as well as in a CollectionView within
 * the field view.
 *
 * @see SelectFieldView
 * @see SelectFieldSelectorModal
 */
export const SelectFieldSelections = Backbone.Collection.extend({
    model: Backbone.Model.extend({
        idAttribute: 'title',
        defaults: { title: '' }
    }),

    initialize: function (models, options) {
        models = this._convert_strings_to_model_json(models);
        SelectFieldSelections.__super__.initialize.call(this, models, options);
    },

    add: function (models, options) {
        models = this._convert_strings_to_model_json(models);
        SelectFieldSelections.__super__.add.call(this, models, options);
    },

    /**
     * Since this collection represents string values as models, we need to convert
     * any strings --> json {} that can be converted to models. @see add() and initialize().
     */
    _convert_strings_to_model_json: function (models) {
        if (!(models instanceof Array)) {
            models = [models];
        }

        models = $.map(models, function (model, i) {
            if (typeof model == 'string') {
                model = { title: model };
            }
            return model;
        });

        return models;
    },

    /**
     * Serialize this back into a []
     */
    toJSON: function () {
        return this.pluck('title');
    }
});
